import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENVIRONMENT } from '../../../environment/environment';
import { ErrorService } from './error.service';
import { BlockUiService } from '../libs/shared/components/block-ui/block-ui.service';
import { map, Observable, finalize } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FileDownloadService {
    private route = ENVIRONMENT.apiDomain + '/api/v1/document/attachment';

    constructor(
        private http: HttpClient,
        private errorService: ErrorService,
        private blockUiService: BlockUiService,
    ) { }

    downloadFileFromApi(id: number): void {
        this.blockUiService.open();

        this.http
            .get(`${this.route}/${id}`, {
                observe: 'response',
                responseType: 'blob',
            })
            .pipe(
                finalize(() => {
                    this.blockUiService.close();
                }),
            )
            .subscribe({
                next: (response) => {
                    this.downloadFileFromBlob(response);
                },
                error: (error) => {
                    this.errorService.showError(error);
                },
            });
    }

    downloadFileFromBlob(response: HttpResponse<Blob>, defaultFileName?: string): void {
        const blob = response.body!;
        const contentDisposition = response.headers.get('Content-Disposition');

        let filename = defaultFileName;

        if (contentDisposition) {
            const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

            if (matches?.[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = url;
        a.download = filename!;
        a.click();

        window.URL.revokeObjectURL(url);
    }

    getPreviewUrl(id: number): Observable<string> {
        return this.http
            .get(`${this.route}/${id}`, {
                responseType: 'blob',
            })
            .pipe(map((blob) => URL.createObjectURL(blob)));
    }
}
